module.exports = __webpack_public_path__ + "static/media/gsteps-poster.f94f65b7.png";